export default {"src":"/_next/static/media/Snapshot.ac78cbe2.svg","height":92,"width":91};